import type { PdfAnnotation, ProjectFile } from '../types';
import { pdfAnnotationHasUnreadForUser } from './pdfAnnotationMentionUtils';
import { normalizeStoragePath } from './projectFileRef';

export function pdfAnnotationMatchesProjectFile(
  ann: Pick<PdfAnnotation, 'documentId' | 'documentUrl'>,
  file: Pick<ProjectFile, 'id' | 'url'> & Partial<Pick<ProjectFile, 'sourceLeadDocumentId' | 'storagePath'>>,
): boolean {
  const id = (file.id || '').trim();
  const url = (file.url || '').trim();
  const docId = (ann.documentId || '').trim();
  const docUrl = (ann.documentUrl || '').trim();
  const leadDocId = (file.sourceLeadDocumentId || '').trim();
  if (leadDocId && (docId === leadDocId || docUrl === leadDocId)) return true;
  if (id && (docId === id || docUrl === url)) return true;
  if (url && (docUrl === url || docId === url)) return true;
  const filePath = normalizeStoragePath(file.storagePath || url);
  const annPath = normalizeStoragePath(docUrl || docId);
  if (filePath && annPath && filePath === annPath) return true;
  return false;
}

/** Root pins + replies on a project file (matches documentId / documentUrl keys). */
export function countCommentsOnProjectFile(
  annotations: PdfAnnotation[],
  file: Pick<ProjectFile, 'id' | 'url'>,
): number {
  let total = 0;
  for (const ann of annotations) {
    if (!pdfAnnotationMatchesProjectFile(ann, file)) continue;
    total += 1 + (ann.replies?.length ?? 0);
  }
  return total;
}

/** Unread root pins + replies on a project file for this user. */
export function countUnreadCommentsOnProjectFile(
  annotations: PdfAnnotation[],
  file: Pick<ProjectFile, 'id' | 'url'>,
  userId: string,
): number {
  if (!userId) return 0;
  let total = 0;
  for (const ann of annotations) {
    if (!pdfAnnotationMatchesProjectFile(ann, file)) continue;
    if (!pdfAnnotationHasUnreadForUser(ann, userId)) continue;
    total += 1 + (ann.replies?.length ?? 0);
  }
  return total;
}
